import React from 'react';
import PropTypes from 'prop-types';

import { Text, Link, Button } from '@olxbr/ds-web';
import Barcode from '@olxbr/olx-icons/dist/System/Barcode';
import Visa from '@olxbr/olx-icons/dist/Flagship/Visa';
import Mastercard from '@olxbr/olx-icons/dist/Flagship/Mastercard';
import Amex from '@olxbr/olx-icons/dist/Flagship/Amex';
import Elo from '@olxbr/olx-icons/dist/Flagship/Elo';
import Hipercard from '@olxbr/olx-icons/dist/Flagship/Hipercard';
import Jcb from '@olxbr/olx-icons/dist/Flagship/Jcb';
import Diners from '@olxbr/olx-icons/dist/Flagship/Diners';

import { isMobile } from '../../../core/components/mobile-apps/service/mobile';
import Cards from './components/Cards';
import Dropdown from './components/Dropdown';
import ContactModal from './components/ContactModal';
import DescriptionPlans from './components/DescriptionPlans';
import {
  Wrapper,
  CardsContainer,
  PaymentText,
  PaymentContainer,
  NeedHelpContainer,
  TextContainer,
  WrapperPlansDescription,
  IconsContainer,
} from './styles';

import useModal from './hooks/useModal';
import useAutosPlansSubscription from './useAutosPlansSubscription';
import buildCardsData from './buildCardsData';

function AutosPlansSubscription({
  productsData,
  posData,
  adData,
  extrasData,
}) {
  const plan = useAutosPlansSubscription();
  const contactModal = useModal();
  const plansData = buildCardsData(plan.adQuantity, productsData.subscriptionList);

  return (
    <Wrapper id="AutosPlans" justifyContent="center" alignItems="center" flexDirection="column">
      <ContactModal posData={posData} isOpen={contactModal.isOpen} onClose={contactModal.onClose} />
      <Text.TitleMedium style={{ textAlign: 'center' }}>Quantos anúncios você quer publicar por mês?</Text.TitleMedium>
      <Dropdown onSelect={plan.onChangeAdQuantity} openContactModal={contactModal.onOpen} posData={posData} />
      <CardsContainer>
        <Cards
          plansData={plansData}
          posData={posData}
          adData={adData}
          extrasData={extrasData}
        />
      </CardsContainer>
      <WrapperPlansDescription justifyContent="center" alignItems="center" flexDirection="column">
        <Text.BodyLarge>Todos os planos tem cobrança mensal recorrente, até o cancelamento. Você pode cancelar a qualquer momento sem multa.</Text.BodyLarge>
        <PaymentContainer align-items="center">
          <PaymentText>Forma de pagamento</PaymentText>
          <IconsContainer id="icon-container" alignItems="center">
            <Barcode width={18} height={18} />
            <Visa width={18} height={18} />
            <Mastercard width={18} height={18} />
            <Amex width={18} height={18} />
            <Elo width={18} height={18} />
            <Hipercard width={18} height={18} />
            <Jcb width={18} height={18} />
            <Diners width={18} height={18} />
          </IconsContainer>
        </PaymentContainer>
        <Text.BodyLarge>
          Para anunciar em outras categorias <Link size="large" href="https://www.olx.com.br/planos">clique aqui</Link>
        </Text.BodyLarge>
        <NeedHelpContainer>
          <img src="https://static.olx.com.br/autos/autos-pro/need-help.png" alt="Precisa de ajuda?" />
          <TextContainer flexDirection="column">
            <Text.TitleSmall>Precisa de ajuda com os planos?</Text.TitleSmall>
            <Text.BodySmall>Se você quer planos maiores ou já é cliente OLX, converse com a nossa equipe de vendas!</Text.BodySmall>
          </TextContainer>
          <Button size={isMobile ? 'small' : 'medium'} onClick={contactModal.onOpen}>Fale com a gente</Button>
        </NeedHelpContainer>
        <DescriptionPlans />
      </WrapperPlansDescription>
    </Wrapper>
  );
}


AutosPlansSubscription.propTypes = {
  productsData: PropTypes.object,
  posData: PropTypes.object,
  adData: PropTypes.object,
  extrasData: PropTypes.object,
};

AutosPlansSubscription.defaultProps = {
  productsData: {},
  posData: {},
  adData: {},
  extrasData: {},
};

export default AutosPlansSubscription;
